import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LocaleService } from '@app/+authenticated/shared/locale/locale.service';
import { formatDate, parseDate } from '@shiftbase-com/ts-shared/utilities';

import { CustomFieldsModel } from '../../../../../../reducers/orm/custom-fields/custom-fields.model';
import { DepartmentModel } from '../../../../../../reducers/orm/department/department.model';
import { LocationModel } from '../../../../../../reducers/orm/location/location.model';
import { RateCardModel } from '../../../../../../reducers/orm/rate-card/rate-card.model';
import { TimesheetModel } from '../../../../../../reducers/orm/timesheet/timesheet.model';
import {
  TimesheetColumns,
  TimesheetCustomFieldsColumns,
} from '../../../../../../reducers/page-filters/page-filters.model';
import { TimesheetScheduleDeviations } from '../../../interfaces';

@Component({
  standalone: false,
  selector: 'timesheet-row-timesheet',
  templateUrl: './timesheet-row-timesheet.component.html',
})
export class TimesheetRowTimesheetComponent implements OnChanges {
  #localeService = inject(LocaleService);

  @Input()
  timesheet: TimesheetModel;
  @Input()
  customFields: CustomFieldsModel[] = [];

  @Input()
  locations: { [id: string]: LocationModel };
  @Input()
  department: DepartmentModel;

  selectedRateCard: RateCardModel;

  @Input()
  set rateCards(rateCards: RateCardModel[]) {
    this.selectedRateCard = rateCards.find((rateCard) => rateCard.id == this.timesheet.rate_card_id);
  }

  @Input()
  absenceWarning: boolean;
  @Input()
  doubleRegistration: boolean;
  @Input()
  deviationsFromSchedule: TimesheetScheduleDeviations;
  @Input()
  first: boolean;
  @Input()
  cols: TimesheetColumns;
  @Input()
  customFieldCols: TimesheetCustomFieldsColumns;

  location = '';
  surcharge = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['locations'] || changes['department']) {
      this.location = this.getLocation();
    }

    if (changes['rateCards']) {
      this.surcharge = this.getSurcharge();
    }
  }

  private getLocation() {
    if (this.locations && this.department) {
      const loc = this.locations[this.department.location_id];

      return loc ? loc.name : '';
    } else {
      return '';
    }
  }

  private getSurcharge() {
    if (this.selectedRateCard) {
      const deleted = this.selectedRateCard.deleted
        ? ' - ' +
          formatDate(parseDate(this.selectedRateCard.deleted_date), this.#localeService.getCurrentLocale(), 'short')
        : '';

      return this.selectedRateCard.name + deleted;
    } else {
      return '';
    }
  }
}
